import { render } from "./HeaderCart.vue?vue&type=template&id=007516fd"
import script from "./HeaderCart.vue?vue&type=script&lang=js"
export * from "./HeaderCart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__